/**
 * Offre de Poste slider
 */
(function($) {
    "use strict";

    $(window).ready(slickify);

    // Constants
    var offreItems = ".field--name-field-offre-de-poste";
    var dots = offreItems + " .slick-dots";
    /**
     * Init
     */
    function slickify() {

        if ($(offreItems).children().children().children().length > 2) {
            $(offreItems).not('.slick-initialized').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                vertical: false,
                dots: true,
                arrows: true
            });
        } else {
          $(dots).css("display","none");
        }

    }

})(jQuery);